module.exports = __webpack_public_path__ + "img/appIcon-ui--paymentsBill.6a0ea92c.svg";